import { Injectable } from '@angular/core';

export interface TslSession {
  cid: string;
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
}

const COOKIE_NAME = 'tsl_session';

@Injectable({
  providedIn: 'root',
})
export class TslSessionService {
  initFromUrl(): void {
    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source');
    const utmMedium = params.get('utm_medium');

    if (utmSource?.toLowerCase() !== 'tsl' || utmMedium?.toLowerCase() !== 'livestream') {
      return;
    }

    const session: TslSession = {
      cid: params.get('cid') ?? '',
      utmSource,
      utmMedium,
      utmCampaign: params.get('utm_campaign') ?? '',
    };

    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(session))};path=/`;
  }

  getSession(): TslSession | null {
    const match = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${COOKIE_NAME}=`));

    if (!match) return null;

    try {
      return JSON.parse(decodeURIComponent(match.split('=').slice(1).join('=')));
    } catch {
      return null;
    }
  }

  clearSession(): void {
    document.cookie = `${COOKIE_NAME}=;path=/;max-age=0`;
  }
}
